import type { ReactNode } from 'react';

export type Tone = 'primary' | 'info' | 'success' | 'warning' | 'danger' | 'neutral';

interface BadgeProps {
  tone?: Tone;
  children?: ReactNode;
}

export function Badge({ tone, children }: BadgeProps) {
  return <span className={'mp-badge mp-badge--' + (tone || 'neutral')}>{children}</span>;
}
